module.exports = __webpack_public_path__ + "static/img/zzkfz.a405630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zzkfz.png
// module id = nkVY
// module chunks = 3